import React, { Component, useState } from "react";
import Scheduler, { SchedulerData, ViewTypes } from "react-big-scheduler";
import WithDragDropContext from "./withDnDContext";
import "./demo.css";
import axios from "axios";
import Col from "antd/lib/col";
import Row from "antd/lib/row";
import Button from "antd/lib/button";
import "react-big-scheduler/lib/css/style.css";
import CreateShiftTask from "../CreateShiftTask";
import EditCreateShiftTask from "../EditCreateShiftTask";
import FromTemplate from "../FromTemplate";
import { Link } from "react-router-dom";
import GenericShiftcreation from "../GenericShiftcreation";
import ClientSideshift from "../ClientSideshift";
import "moment/locale/en-gb";
import {
  combineShiftDateTime,
  convertTimeToUserTimeZone,
  getFullName,
  getWeekStartAndEndDates,
  handleDataPrint,
  isDateTimeGreaterThanCurrent,
  sortByDate,
} from "../../../utils/CommonFunctions";
import { currentCareSiteId } from "../../../redux-toolkit/reducer/switchSites";
import { httpAdmin } from "../../../Apis/commonApis";
import { ShowInfoSwal, ShowSwal } from "../../../utils/alertSwal";
import { AiFillPrinter } from "react-icons/ai";
import JsonDownload from "../../../components/DownloadExcel/DownloadExcel";
import swal from "sweetalert";
import CareTeamReassignment from "./CareTeamReassignment";
import ShiftCompletionPopup, { isTimeBetween } from "./ShiftCompletionPopup";
import ShiftCreationModalAgency from "./AgencyShiftCreation";
import AgencyShiftUpdate from "./AgencyShiftUpdate";

const defaultUserImg = `${process.env.REACT_APP_REDIRECTION_URL_PLAN}/admin/images/chatUser.svg`;

class Basic extends Component {
  constructor(props) {
    super(props);
    const pageHeight = window.innerHeight - 350;
    //let schedulerData = new SchedulerData(new moment("2017-12-18").format(DATE_FORMAT), ViewTypes.Week);
    this.schedulerData = new SchedulerData(
      new Date(),
      ViewTypes.Week,
      false,
      false,
      {
        schedulerWidth: "87%",
        besidesWidth: 0,
        defaultEventBgColor: "#808080",
        resourceName: "Name",
        movable: true,
        creatable: true,
        crossResourceMove: false,
        eventItemPopoverEnabled: true,
        calendarPopoverEnabled: true,
        dayResourceTableWidth: 180,
        weekResourceTableWidth: 180,
        eventItemHeight: 35,
        eventItemLineHeight: 40,
        schedulerMaxHeight: pageHeight,
        selectedAreaColor: "#808080",
        recurringEventsEnabled: true,
        headerEnabled: true,
        displayWeekend: true,
        nonWorkingTimeHeadColor: "grey",
        nonWorkingTimeHeadBgColor: "white",
        nonWorkingTimeBodyBgColor: "white",
        groupOnlySlotColor: "#808080.",
        startResizable: true,
        customCellWidth: 80,
        dayCellWidth: "5%",
        endResizable: true,
        weekCellWidth: "12%",
        views: [
          {
            viewName: "Day",
            viewType: ViewTypes.Day,
            showAgenda: false,
            isEventPerspective: false,
          },
          {
            viewName: "Week",
            viewType: ViewTypes.Week,
            showAgenda: false,
            isEventPerspective: false,
          },
          {
            viewName: "Month",
            viewType: ViewTypes.Month,
            showAgenda: false,
            isEventPerspective: false,
          },
        ],
      }
    );

    this.schedulerData.localeMoment.locale("en-gb");

    // let EditShiftData = []
    this.state = {
      viewModel: this.schedulerData,
      shownShiftTaskUI: false,
      showEditShiftTaskUI: false,
      formtemplate: false,
      isDisplayed: false,
      genericTem: false,
      clientSide: false,
      resourceArr: [],
      EventsArr: [],
      downloadData: [],
      SchedulerAccess: props.SchedulerAccess,
      EditShiftData: [],
      EditclientShiftData: [],
      intervalId: "",
      siteTimeZone: this.props.siteTimeZone,
      shiftData: [],
      selected: "client",
      openReassignment: false,
      openShiftCompletion: false,
      shiftTaskData: {},
      allCareTeamData: [],
    };
  }

  componentDidMount() {
    // const intervalId = setInterval(() => {
    this.getShiftsandtaskNew("refresh");
    // }, 60000);
    // this.getShiftsandtaskNew("refresh");
    // this.setState(() => ({ intervalId: intervalId }));
  }

  componentWillUnmount() {
    // clearInterval(this.state.intervalId);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.text !== this.props.text) {
      let filteredVal = this.state?.resourceArr?.filter((elem) => {
        return elem?.name.toLowerCase().includes(this.props.text.toLowerCase());
      });

      this.schedulerData.setResources(filteredVal);
      this.forceUpdate(); // Force a re-render of the component
    }
    if (prevProps.reloadData !== this.props.reloadData) {
      this.getShiftsandtaskNew("refresh");
    }
    if (prevProps.siteTimeZone !== this.props.siteTimeZone) {
      this.setState((prevState) => ({
        ...prevState,
        siteTimeZone: this.props.siteTimeZone,
      }));
      this.forceUpdate(); // Force a re-render of the component
    }
  }

  getShiftsandtaskNew = async (type, dataType) => {
    const start = this.state.viewModel.startDate;
    const end = this.state.viewModel.endDate;
    if (type === "closePopup") {
      this.setState((prevState) => ({
        shownShiftTaskUI: false,
        showEditShiftTaskUI: false,
      }));
    }
    const endPointString = `getShiftsandtaskNew?careHomeId=${currentCareSiteId}&startDate=${start}&endDate=${end}&type=${
      dataType ?? this.state.selected
    }`;
    let res = await httpAdmin(endPointString, "get", null, null);
    if (res.status) {
      if (res.clients) {
        const allClients = res?.clients ?? [];
        const resource = [];
        const events = [];
        const downloadArr = [];
        const filterInactiveClients = allClients.filter(
          (item) =>
            item.clientStatus === "active" || item.clientStatus === "closed"
        );
        filterInactiveClients?.forEach((client) => {
          const id = client?._id ? client?._id : "";
          const name = getFullName(client);
          //  `${client?.first_Name} ${client?.last_Name}`;
          const image = client?.image;
          const shiftDataForClient = res?.shiftData.filter((item) =>
            item.shiftMappings.some((elem) =>
              elem.clientId.includes(client._id)
            )
          );
          // console.log(shiftDataForClient, name);
          shiftDataForClient?.forEach((shiftObj) => {
            if (shiftObj?.templateType === "") {
              let bgColor = "";
              if (shiftObj?.recurringShiftType === "open") {
                bgColor = "purple";
              } else if (shiftObj?.recurringShiftType === "unassigned") {
                bgColor = "#F2994A";
              } else if (shiftObj?.status == "pending") {
                bgColor = "#898988";
              } else if (shiftObj?.status == "In-Process") {
                bgColor = "#007fff";
              } else if (shiftObj?.status == "overdue") {
                bgColor = "#EB5757";
              } else if (shiftObj?.status == "Done") {
                bgColor = "#219653";
              } else {
                bgColor = "#898988";
              }

              const shiftTaskList = res.tasks?.filter(
                (item) =>
                  item.clientId === client._id &&
                  item.shiftDate?.split("T")?.[0] === shiftObj.Date
              );
              // console.log(shiftTaskList, "shiftTaskList----------");
              const filterByTaskTime = shiftTaskList.filter((item) => {
                const globalTask = item?.globalTask;
                if (globalTask?.medName) {
                  const [startTime, endTime] = item.schedule?.[0]?.split("-");
                  return isTimeBetween(
                    shiftObj?.startingTime,
                    shiftObj?.endingTime,
                    startTime ?? "",
                    endTime ?? ""
                  );
                } else {
                  return globalTask?.shiftType?.includes("specific time")
                    ? isTimeBetween(
                        shiftObj?.startingTime,
                        shiftObj?.endingTime,
                        globalTask?.startTime,
                        globalTask?.endTime
                      )
                    : true;
                }
              });

              if (shiftObj?.recurringShiftType === "assigned") {
                const assignedCareMembers = shiftObj?.shiftMappings?.map(
                  (item) => getFullName(item.careteam)
                );
                events.push({
                  shiftId: shiftObj?._id,
                  mainshiftId: shiftObj?.mainshiftId,
                  ShiftData: shiftObj,
                  editShiftId: shiftObj?._id,
                  client,
                  eventType: "careteam",
                  id: shiftObj._id,
                  start: combineShiftDateTime(
                    shiftObj.Date,
                    shiftObj.startingTime
                  ),
                  end: combineShiftDateTime(shiftObj.Date, shiftObj.endingTime),
                  // start:
                  //   shiftObj?.shiftStartDatetime ??
                  //   `${shiftObj.Date} ${shiftObj.startingTime}`,
                  // end:
                  //   shiftObj?.shiftEndDatetime ??
                  //   `${shiftObj.Date} ${shiftObj.endingTime}`,
                  taskList: filterByTaskTime,
                  resourceId: id,
                  title: assignedCareMembers?.join(", "),
                  bgColor: bgColor,
                });
              } else {
                events.push({
                  shiftId: shiftObj._id,
                  mainshiftId: shiftObj?.mainshiftId,
                  ShiftData: shiftObj,
                  client,
                  id: shiftObj._id,
                  start: combineShiftDateTime(
                    shiftObj.Date,
                    shiftObj.startingTime
                  ),
                  end: combineShiftDateTime(shiftObj.Date, shiftObj.endingTime),
                  // start:
                  //   shiftObj?.shiftStartDatetime ??
                  //   `${shiftObj.Date} ${shiftObj.startingTime}`,
                  // end:
                  //   shiftObj?.shiftEndDatetime ??
                  //   `${shiftObj.Date} ${shiftObj.endingTime}`,
                  taskList: filterByTaskTime,
                  resourceId: id,
                  title: shiftObj?.recurringShiftType,
                  bgColor: bgColor,
                });
              }
              // Client Name, Date, Shift Start Time, Shift End Time, Shift Hrs (hrs, minutes).
              downloadArr.push({
                ["Client Name"]: name,
                ["Date"]: shiftObj.Date,
                ["Shift Start Time"]: shiftObj.startingTime,
                ["Shift End Time"]: shiftObj.endingTime,
              });
            }
          });
          resource.push({ id, name, image });
        });

        this.schedulerData.setResources(resource);
        this.schedulerData.setEvents(sortByDate(events, "start", ""));
        this.setState((prevState) => ({
          ...prevState,
          EventsArr: events,
          resourceArr: resource,
          downloadData: downloadArr,
        }));
      } else {
        const allCareTeam = res?.careteams ?? [];
        const resource = [];
        const events = [];
        const downloadArr = [];
        allCareTeam?.forEach((careteam) => {
          const id = careteam?._id ? careteam?._id : "";
          const name = getFullName(careteam);
          //  `${careteam?.first_Name} ${careteam?.last_Name}`;
          const image = careteam?.image;
          const shiftDataForClient = res?.shiftData.filter((item) =>
            item.shiftMappings?.some(
              (elem) => elem.careteam?._id === careteam._id
            )
          );
          shiftDataForClient?.forEach((shiftObj) => {
            if (shiftObj?.templateType === "") {
              let bgColor = "";
              if (shiftObj?.recurringShiftType === "open") {
                bgColor = "purple";
              } else if (shiftObj?.status == "pending") {
                bgColor = "#898988";
              } else if (shiftObj?.status == "In-Process") {
                bgColor = "#007fff";
              } else if (shiftObj?.status == "overdue") {
                bgColor = "#EB5757";
              } else if (shiftObj?.status == "Done") {
                bgColor = "#219653";
              } else {
                bgColor = "#898988";
              }

              const taskClientId = shiftObj?.shiftMappings?.[0]?.clientId[0];

              const shiftTaskList = res.tasks?.filter(
                (tItem) =>
                  tItem.clientId === taskClientId &&
                  tItem.shiftDate?.split("T")?.[0] === shiftObj.Date
              );
              const filterByTaskTime = shiftTaskList.filter((item) => {
                const globalTask = item?.globalTask;
                if (globalTask?.medName) {
                  return isTimeBetween(
                    shiftObj?.startingTime,
                    shiftObj?.endingTime,
                    globalTask.startTime,
                    globalTask.endTime
                  );
                } else {
                  return globalTask?.shiftType?.includes("specific time")
                    ? isTimeBetween(
                        shiftObj?.startingTime,
                        shiftObj?.endingTime,
                        globalTask.startTime,
                        globalTask.endTime
                      )
                    : true;
                }
              });

              if (
                shiftObj?.recurringShiftType === "assigned" ||
                shiftObj?.recurringShiftType === "Done"
              ) {
                const assignedClients = shiftObj?.shiftMappings
                  .filter((item) => item.careTeamId === careteam._id)
                  ?.map((item) => {
                    const allClient = item.client?.map((elem) =>
                      getFullName(elem)
                    );
                    return allClient;
                  })
                  .flat();

                events.push({
                  shiftId: shiftObj?._id,
                  mainshiftId: shiftObj?.mainshiftId,
                  ShiftData: shiftObj,
                  editShiftId: shiftObj?._id,
                  client: careteam,
                  eventType: "client",
                  id: shiftObj._id,
                  start:
                    shiftObj?.shiftStartDatetime ??
                    `${shiftObj.Date} ${shiftObj.startingTime}`,
                  taskList: filterByTaskTime,
                  end:
                    shiftObj?.shiftEndDatetime ??
                    `${shiftObj.Date} ${shiftObj.endingTime}`,
                  resourceId: id,
                  title: assignedClients?.join(", "),
                  bgColor: bgColor,
                });
              }
              downloadArr.push({
                ["Client Name"]: name,
                ["Date"]: shiftObj.Date,
                ["Shift Start Time"]: shiftObj.startingTime,
                ["Shift End Time"]: shiftObj.endingTime,
              });
            }
          });
          resource.push({ id, name, image, type: "careteam" });
        });

        this.schedulerData.setResources(resource);
        this.schedulerData.setEvents(sortByDate(events, "start", ""));
        this.setState((prevState) => ({
          ...prevState,
          EventsArr: events,
          resourceArr: resource,
          downloadData: downloadArr,
          allCareTeamData: res?.careteams,
        }));
      }
    }
  };

  toggleShowHide = (events, type) => {};

  toggle = () => {
    this.setState((state) => ({
      isDisplayed: !state.isDisplayed,
      shownShiftTaskUI: state.showEditShiftTaskUI,
      // EditShiftData: events.resourceData.shiftData[0]
    }));
  };

  hide = () => {
    this.setState((state) => ({
      isDisplayed: !state.isDisplayed,
      shownShiftTaskUI: state.showEditShiftTaskUI,
    }));
  };

  clear = () => {
    this.setState((state) => ({
      isDisplayed: !state.isDisplayed,
      shownShiftTaskUI: state.shownShiftTaskUI,
      formtemplate: !state.formtemplate,
    }));
  };

  close = () => {
    this.setState((state) => ({
      genericTem: !state.genericTem,
    }));
  };

  clientTem = () => {
    this.setState((state) => ({
      clientSide: !state.clientSide,
    }));
  };

  deleteShift(eventItem, type) {
    let data = {
      decline: false,
    };
    if (type === "one") {
      data.shiftId = eventItem?.shiftId;
    } else {
      data.mainshiftId = eventItem?.mainshiftId;
    }
    swal({
      title: "Confirmation!",
      content: {
        element: "div",
        attributes: {
          innerHTML:
            '<span style="color:red;">Important: Is the shift declined by the care team member?</span>',
        },
      },
      // text: "Important: Is the shift declined by the care team member?",
      buttons: {
        cancelAction: {
          text: "No",
          value: "cancel",
          visible: true,
          className: "cancel-btn",
        },
        outsideAction: {
          text: "Dismiss",
          value: "outside",
          visible: false, // invisible fallback
        },
        confirmAction: {
          text: "Yes",
          value: "confirm",
          className: "confirm-btn",
        },
      },
    }).then((result) => {
      console.log(result, "rrrrrrrrrrr");
      if (result === "confirm") {
        data.decline = true;
        this.handleDeleteShift(data);
      } else if (result === "cancel") {
        data.decline = false;
        this.handleDeleteShift(data);
      }
    });
  }

  handleDeleteShift = async (data) => {
    let res = await httpAdmin("deleteshift", "post", data, null);
    ShowSwal(res.status, res.message);
    if (res.status) {
      this.getShiftsandtaskNew("closePopup");
    }
  };

  handleToggleView = (option) => {
    this.setState({ selected: option });
    this.getShiftsandtaskNew("refresh", option);
  };
  closeopenReassignment = () => {
    this.getShiftsandtaskNew("refresh");
    this.setState({ openReassignment: false });
  };

  closeShiftCompletion = () => {
    this.setState({ openShiftCompletion: false });
  };

  handleShowReassignment = () => {
    this.setState({ openReassignment: true });
  };

  handleCreateShiftClick() {
    const subsriptionStatus = this.props?.subsriptionStatus;
    if (
      subsriptionStatus !== "paused" &&
      subsriptionStatus !== "blocked" &&
      this.state.SchedulerAccess === "full"
    ) {
      this.setState((prevState) => ({
        shownShiftTaskUI: !prevState.shownShiftTaskUI,
      }));
    } else {
      ShowSwal(
        false,
        subsriptionStatus == "blocked"
          ? "This site is blocked. Kindly clear outstanding payments to activate it again."
          : "Kindly renew your subscription in order for this functionality to work."
      );
    }
  }

  handleProxyBtnClick(eventItem) {
    if (this.state.SchedulerAccess === "full") {
      this.setState({ shiftTaskData: eventItem });
      this.setState({ openShiftCompletion: true });
    } else {
      ShowInfoSwal("Your user Role does not have access to this section");
    }
  }

  render() {
    const {
      viewModel,
      downloadData,
      selected,
      openReassignment,
      allCareTeamData,
    } = this.state;
    return (
      <>
        <div className="col-md-2 ps-2">
          <AiFillPrinter
            className="me-3 ms-1 curser_point"
            onClick={() => handleDataPrint(downloadData)}
          />
          <a className="curser_point">
            <JsonDownload
              fileName="shifttasks-excel"
              downloadfile={downloadData}
            />
          </a>
        </div>

        <div className="col-md-11 d-flex justify-content-start gap-1 py-0 my-2">
          <button
            className={`btn ${
              selected === "client"
                ? "btn-toggle-active"
                : "btn-toggle-inactive"
            }`}
            onClick={() => this.handleToggleView("client")}
          >
            Client
          </button>
          <button
            className={`btn ${
              selected === "careteam"
                ? "btn-toggle-active"
                : "btn-toggle-inactive"
            }`}
            onClick={() => this.handleToggleView("careteam")}
          >
            Care Team
          </button>
        </div>

        <div className="float-end btns_head" style={{ marginTop: "-43px" }}>
          {selected === "client" ? (
            <button
              className="btn btn-theme btn-md"
              disabled={this.state.SchedulerAccess !== "full"}
              onClick={() => this.handleCreateShiftClick()}
            >
              Create Shift
            </button>
          ) : (
            <button
              className="btn btn-theme btn-md"
              disabled={this.state.SchedulerAccess !== "full"}
              onClick={() => {
                this.handleShowReassignment();
              }}
            >
              Reassign Staff
            </button>
          )}
        </div>

        <div
          style={{
            height: "calc(100vh - 260px)",
            overflowY: "auto",
            overflowX: "hidden",
            width: "100%",
          }}
        >
          {!this.state.shownShiftTaskUI &&
            !this.state.showEditShiftTaskUI &&
            !this.state.formtemplate &&
            (selected === "client" ? (
              <Scheduler
                schedulerData={viewModel}
                prevClick={this.prevClick}
                nextClick={this.nextClick}
                onSelectDate={this.onSelectDate}
                onViewChange={this.onViewChange}
                eventItemClick={this.eventClicked}
                // updateEventStart={this.updateEventStart}
                // updateEventEnd={this.updateEventEnd}
                moveEvent={this.moveEvent}
                newEvent={this.newEvent}
                onScrollLeft={this.onScrollLeft}
                onScrollRight={this.onScrollRight}
                toggleExpandFunc={this.toggleExpandFunc}
                eventItemPopoverTemplateResolver={
                  this.eventItemPopoverTemplateResolver
                }
                eventItemTemplateResolver={this.eventItemTemplateResolver}
                slotItemTemplateResolver={this.slotItemTemplateResolver}
                movingEvent={this.movingEvent}
              />
            ) : (
              <Scheduler
                schedulerData={viewModel}
                prevClick={this.prevClick}
                nextClick={this.nextClick}
                onSelectDate={this.onSelectDate}
                onViewChange={this.onViewChange}
                eventItemClick={this.eventClicked}
                // updateEventStart={this.updateEventStart}
                // updateEventEnd={this.updateEventEnd}
                moveEvent={this.moveEvent}
                newEvent={this.newEvent}
                onScrollLeft={this.onScrollLeft}
                onScrollRight={this.onScrollRight}
                toggleExpandFunc={this.toggleExpandFunc}
                eventItemPopoverTemplateResolver={
                  this.eventItemPopoverTemplateResolver
                }
                eventItemTemplateResolver={this.eventItemTemplateResolver}
                slotItemTemplateResolver={this.slotItemTemplateResolver}
                movingEvent={this.movingEvent}
              />
            ))}
        </div>
        {this.state.openShiftCompletion && (
          <ShiftCompletionPopup
            shiftTaskData={{
              allShiftData: this.state.shiftTaskData?.ShiftData,
              taskList: this.state.shiftTaskData?.taskList,
            }}
            closeShiftCompletion={this?.closeShiftCompletion}
          />
        )}
        {/* Create Shift POPup */}
        {
          <div
            className="modal"
            style={{
              display: this.state.shownShiftTaskUI ? "block" : "none",
            }}
          >
            <div>
              <div className="bg_popup"></div>
              <div className="modal-dialog modal-lg">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">
                      Shift Creation
                      <small>
                        {this.state.siteTimeZone
                          ? ` (Timezone used for shift creation - ${this.state.siteTimeZone})`
                          : ""}
                      </small>
                    </h5>
                    <Link
                      className="btn-close"
                      onClick={() => {
                        this.setState((prevState) => ({
                          shownShiftTaskUI: !prevState.shownShiftTaskUI,
                        }));
                      }}
                      to="#"
                    ></Link>
                    {/* <button type="button" className="btn-close"></button> */}
                  </div>
                  <div className="">
                    {this.state.shownShiftTaskUI && (
                      // <CreateShiftTask
                      //   shownShiftTaskUI={this.state.shownShiftTaskUI}
                      //   getShiftsandtaskNew={this.getShiftsandtaskNew}
                      // />
                      <ShiftCreationModalAgency
                        shownShiftTaskUI={this.state.shownShiftTaskUI}
                        getShiftsandtaskNew={this.getShiftsandtaskNew}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        }

        {/* {this.state.shownShiftTaskUI && (
          <ShiftCreationModalAgency
            allCareTeam={allCareTeamData}
            openReassignment={openReassignment}
            closeopenReassignment={this.closeopenReassignment}
          />
        )} */}

        <div
          className="modal m-5"
          style={{
            display: this.state.genericTem ? "block" : "none",
            width: "90%",
          }}
        >
          <div className="bg_popup"></div>
          <div className="modal-dialog-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Generic Template Creation
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={this.close}
                  to="#"
                ></button>
              </div>
              <div className="modal-body">
                {this.state.genericTem && (
                  <GenericShiftcreation
                    genericTem={this.state.genericTem}
                    close={this.close}
                  />
                )}
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal m-5"
          style={{
            display: this.state.clientSide ? "block" : "none",
            width: "92%",
            height: "92%",
          }}
        >
          <div className="bg_popup"></div>
          <div className="modal-dialog-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Client Template Creation
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={this.clientTem}
                  to="#"
                ></button>
              </div>
              <div className="modal-body">
                {this.state.clientSide && (
                  <ClientSideshift
                    clientSide={this.state.clientSide}
                    clientTem={this.clientTem}
                  />
                )}
              </div>
            </div>
          </div>
        </div>

        {/* // FormTemplate */}
        <div
          className={`modal ${this.state.isDisplayed ? "" : ""}`}
          id="formTemplate"
          style={{
            display: `${this.state.formtemplate ? "block" : "none"}`,
          }}
        >
          <div className="bg_popup"></div>
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Form Template</h4>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    this.setState((prevState) => ({
                      formtemplate: !prevState.formtemplate,
                    }));
                    document.body?.classList?.remove("modal-scroll");
                  }}
                ></button>
              </div>

              <div className="modal-body">
                {" "}
                {this.state.formtemplate && (
                  <FromTemplate
                    fromtemplatestatus={this.state.formtemplate}
                    onClick={this.toggleShowHide}
                    isDisplayed={this.state.isDisplayed}
                    hide={this.hide}
                    clear={this.clear}
                    toggle={this.toggle}
                    genericTem={this.state.genericTem}
                    close={this.close}
                    clientSide={this.state.clientSide}
                    clientTem={this.clientTem}
                  />
                )}
              </div>

              <div className="modal-footer"></div>
            </div>
          </div>
        </div>

        {/* <div
          className="modal"
          style={{
            display: this.state.showEditShiftTaskUI ? "block" : "none",
          }}
        >
          <div className="bg_popup"></div>
          <div className="modal-dialog-sm">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Shift Updation
                  <small>
                    {this.state.siteTimeZone
                      ? ` (Timezone used for shift creation - ${this.state.siteTimeZone})`
                      : ""}
                  </small>
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    this.setState((prevState) => ({
                      showEditShiftTaskUI: !prevState.showEditShiftTaskUI,
                    }));
                  }}
                ></button>
              </div>
              <div className="modal-body">
                {this.state.showEditShiftTaskUI && (
                  <EditCreateShiftTask
                    shownEditShiftTaskUI={this.state.showEditShiftTaskUI}
                    titleName="Shift Creation"
                    buttonType="editShift"
                    addCreateShift="editshift"
                    typeshift=""
                    editTaskData={this.state.EditShiftData}
                    data={this.state}
                    getShiftsandtaskNew={this.getShiftsandtaskNew}
                  />
                )}
              </div>
            </div>
          </div>
        </div>  */}

        {this.state.showEditShiftTaskUI && (
          <AgencyShiftUpdate
            shownEditShiftTaskUI={this.state.showEditShiftTaskUI}
            titleName="Shift Creation"
            buttonType="editShift"
            addCreateShift="editshift"
            typeshift=""
            editTaskData={this.state.EditShiftData}
            data={this.state}
            getShiftsandtaskNew={this.getShiftsandtaskNew}
          />
        )}

        <ul className="statusBox text-center">
          <li>
            <span style={{ background: "purple" }}></span>
            Open
          </li>
          <li>
            <span style={{ background: "#F2994A" }}></span>
            Unassigned
          </li>
          <li>
            <span style={{ background: "grey" }}></span>
            Assigned
          </li>
          <li>
            <span style={{ background: "#007fff" }}></span>
            In-process
          </li>
          <li>
            <span style={{ background: "#219653" }}></span>
            Completed
          </li>
          <li>
            <span style={{ background: "#EB5757" }}></span>
            Overdue
          </li>
        </ul>
        {openReassignment && (
          <CareTeamReassignment
            allCareTeam={allCareTeamData}
            openReassignment={openReassignment}
            closeopenReassignment={this.closeopenReassignment}
          />
        )}
      </>
    );
  }

  moveEvent = (schedulerData, event, slotId, slotName, start, end) => {
    let date = start?.split(" ")?.[0];

    schedulerData.moveEvent(event, slotId, slotName, start, end);
    this.setState({
      viewModel: schedulerData,
    });

    var shiftType = [];
    var startTime = [];
    var endTime = [];
    var taskName = [];
    var taskType = [];
    event?.ShiftData?.Task?.forEach((items, index) => {
      shiftType.push(items.shiftType);
      startTime.push(items.startTime);
      endTime.push(items.endTime);
      taskName.push(items.taskName);
      taskType.push(items.taskType);
    });

    if (shiftType.length > 1) {
      var type = "array";
    } else {
      var type = "string";
    }

    var data = new FormData();
    data.append("careHomeId", event.ShiftData.careHomeId);
    data.append("careTeamId", event.ShiftData.careTeamId._id);
    data.append("shiftId", event.ShiftData._id);
    data.append("clientId", event.ShiftData.clientId._id);
    data.append(
      "forClient",
      event.ShiftData.forClient
        ?.split(" ")
        ?.filter((s) => s)
        ?.join(" ")
    );
    data.append(
      "careTeamMember",
      event.ShiftData.careTeamMember
        ?.split(" ")
        ?.filter((s) => s)
        ?.join(" ")
    );
    data.append("Date", date);
    data.append("startingTime", event.ShiftData.startingTime);
    data.append("endingTime", event.ShiftData.endingTime);
    data.append("recurringTask", event.ShiftData.recurringTask);
    data.append("recurringTasktype", event.ShiftData.recurringTasktype);
    data.append("instruction", event.ShiftData.instruction);
    data.append("recurringShiftType", event.ShiftData.recurringShiftType);
    data.append(
      "attachments",
      event.ShiftData.image ? event.ShiftData.image : ""
    );
    data.append("type", type);
    data.append("endDate", event.ShiftData.endDate);
    data.append("shiftType", shiftType);
    data.append("startTime", startTime);
    data.append("endTime", endTime);
    data.append("taskName", taskName);
    data.append("taskType", taskType);

    var config = {
      method: "post",
      url: `${process.env.REACT_APP_BASEURL}/editShift`,
      headers: {
        Authorization: localStorage.getItem("token"),
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        window.location.reload(false);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  movingEvent = (
    schedulerData,
    slotId,
    slotName,
    newStart,
    newEnd,
    action,
    type,
    item
  ) => {
    // console.log('moving event', schedulerData, slotId, slotName, newStart, newEnd, action, type, item);
  };

  eventItemPopoverTemplateResolver = (
    schedulerData,
    eventItem,
    title,
    start,
    end,
    statusColor
  ) => {
    const shiftMappings = eventItem.ShiftData?.shiftMappings;
    const { openShiftCompletion, shiftTaskData } = this.state;
    const isShiftAssigned =
      eventItem.ShiftData?.recurringShiftType === "assigned";

    const shiftStartDateTimeWithGrace =
      eventItem?.item?.shiftStartDatetimeWithGracePeriod;
    let shiftTimeZone = eventItem.ShiftData?.timeZone;
    const isShiftDatepassed = isDateTimeGreaterThanCurrent(
      shiftStartDateTimeWithGrace ?? start.format(),
      new Date()
    );
    // console.log(eventItem?.ShiftData, "eventItem?.ShiftData");
    const showEditBtn =
      eventItem?.ShiftData?.recurringShiftType === "open" ||
      eventItem?.ShiftData?.recurringShiftType === "unassigned" ||
      (eventItem?.ShiftData?.recurringShiftType === "assigned" &&
        eventItem?.ShiftData?.status === "pending" &&
        isShiftDatepassed);
    const isShowProxyBtn =
      eventItem?.ShiftData?.recurringShiftType === "assigned";
    // eventItem?.ShiftData?.status === "pending" ||
    // eventItem?.ShiftData?.status === "overdue";
    // console.log(eventItem, "eventItem?.taskList--------");
    return (
      <div style={{ minWidth: "170px" }}>
        {isShiftAssigned && eventItem.eventType === "careteam" ? (
          shiftMappings?.map((mObj) => {
            const careMember = mObj.careteam;
            const careteamImg = careMember?.image ?? defaultUserImg;
            return (
              <div
                key={mObj._id}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  margin: "5px 0px",
                }}
              >
                <div
                  className="status-dot"
                  style={{ backgroundColor: statusColor }}
                />{" "}
                <img
                  style={{
                    borderRadius: "50%",
                    width: "34px",
                    height: "34px",
                    marginRight: "5px",
                  }}
                  className={`${
                    careteamImg?.includes("chatUser") ? "forImagecareteam" : ""
                  }`}
                  src={careteamImg}
                />
                <span className="header2-text" title={getFullName(careMember)}>
                  {getFullName(careMember)}
                </span>
              </div>
            );
          })
        ) : (
          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <div
              className="status-dot"
              style={{ backgroundColor: statusColor }}
            />
            <span className="header2-text" title={eventItem?.title}>
              {eventItem?.title}
            </span>
          </div>
        )}
        <Row type="flex" align="middle">
          <Col span={2}>
            <div />
          </Col>
          <Col span={22} md={45}>
            <span className="header1-text">
              {start.format("HH:mm")} - {end.format("HH:mm")}
            </span>
          </Col>
        </Row>
        <Row type="flex" align="middle">
          <Col span={2}>
            <div />
          </Col>
          {eventItem?.taskList?.length > 0 && (
            <Col span={55}>
              <span style={{ color: "#EB5757" }}>Task List: </span>
              <ul>
                {eventItem?.taskList?.map((task, index) => {
                  const globalTask = task?.globalTask;
                  const isSpecificTime =
                    globalTask?.shiftType?.includes("specific");
                  // console.log(task, index, "taskkkkkkkkkkkkkkkkk");
                  const conditionsToShowMed =
                    globalTask?.medName &&
                    globalTask?.prn?.toLowerCase() === "no";

                  const conditionsToNotShowTime =
                    globalTask?.medName &&
                    globalTask?.prn?.toLowerCase() === "yes";

                  if (conditionsToShowMed) {
                    return (
                      <li key={index} style={{ textDecoration: "none" }}>
                        Medication Reminder (
                        {task?.schedule[0] ?? globalTask?.schedule})
                      </li>
                    );
                  }
                  if (conditionsToNotShowTime) {
                    return (
                      <li key={index} style={{ textDecoration: "none" }}>
                        PRN Med
                      </li>
                    );
                  }
                  return (
                    <li key={index} style={{ textDecoration: "none" }}>
                      {task.taskCategory === "wellbeing"
                        ? "Wellbeing"
                        : globalTask?.taskType}{" "}
                      (
                      {isSpecificTime
                        ? globalTask?.startTime
                        : // convertTimeToUserTimeZone(
                          //     globalTask?.startTime,
                          //     shiftTimeZone
                          //   )
                          "00:00"}{" "}
                      -{" "}
                      {isSpecificTime
                        ? globalTask?.endTime
                        : // convertTimeToUserTimeZone(
                          //     globalTask?.endTime,
                          //     shiftTimeZone
                          //   )
                          "23:59"}
                      )
                    </li>
                  );
                })}
              </ul>
            </Col>
          )}
        </Row>
        {showEditBtn && (
          <Row type="flex" align="middle">
            <div>
              <Button
                disabled={this.state.SchedulerAccess !== "full"}
                className="mx-3 btn btn-primary"
                onClick={() => {
                  this.EditButtonClicked(eventItem);
                }}
              >
                Edit
              </Button>
            </div>
            <div className="dropdown multiDrop">
              <button
                disabled={this.state.SchedulerAccess !== "full"}
                className="btn btn-primary dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
              >
                Delete
              </button>
              <ul className="dropdown-menu">
                <li>
                  <a
                    style={{ cursor: "pointer" }}
                    className="dropdown-item"
                    onClick={() => {
                      this.deleteShift(eventItem, "one");
                    }}
                  >
                    Delete this shift
                  </a>
                  {/* <a className="dropdown-item" href="#">From Template</a> */}
                </li>
                <li>
                  <a
                    style={{ cursor: "pointer" }}
                    className="dropdown-item"
                    onClick={() => {
                      this.deleteShift(eventItem, "all");
                    }}
                  >
                    Delete All associated recurring shift
                  </a>
                </li>
              </ul>
            </div>
            {/* <Button
              className="btn btn-primary"
              onClick={() => {
                this.deleteShift(eventItem.id);
              }}
            >
              Delete
            </Button> */}
          </Row>
        )}
        {!showEditBtn && isShowProxyBtn && (
          <Row type="flex" align="middle">
            <div>
              <Button
                className="mx-3 btn btn-primary"
                disabled={this.state.SchedulerAccess !== "full"}
                onClick={() => this.handleProxyBtnClick(eventItem)}
              >
                Proxy
              </Button>
            </div>
          </Row>
        )}
      </div>
    );
  };

  EditButtonClicked = (event) => {
    this.setState((prevState) => ({
      showEditShiftTaskUI: !prevState.showEditShiftTaskUI,
      // EditTaskData: prevState.EventsArr.filter(task => task.id === event.id),
      EditShiftData: event,
    }));
  };

  slotItemTemplateResolver(
    schedulerData,
    slot,
    slotClickedFunc,
    width,
    clsName
  ) {
    let resourceData = schedulerData.getSlotById(slot.slotId);
    let dp = resourceData?.image ?? defaultUserImg;
    return (
      <span className="schedulerResourse">
        <img
          className={`profile_img_calendar ${
            dp?.includes("chatUser") && resourceData?.type == "careteam"
              ? "forImagecareteam"
              : ""
          }`}
          src={`${dp}`}
        />{" "}
        <span>{slot.slotName}</span>
      </span>
    );
  }

  prevClick = (schedulerData) => {
    schedulerData.prev();
    schedulerData.setEvents(this.state?.EventsArr);
    this.setState({
      viewModel: schedulerData,
    });
    this.getShiftsandtaskNew("refresh");
  };

  nextClick = (schedulerData) => {
    schedulerData.next();
    schedulerData.setEvents(this.state?.EventsArr);
    this.setState({
      viewModel: schedulerData,
    });
    this.getShiftsandtaskNew("refresh");
  };

  onViewChange = (schedulerData, view) => {
    schedulerData.setViewType(
      view.viewType,
      view.showAgenda,
      view.isEventPerspective
    );
    schedulerData.setEvents(this.state.EventsArr);
    this.setState({
      viewModel: schedulerData,
    });
    this.getShiftsandtaskNew("refresh");
  };

  onSelectDate = (schedulerData, date) => {
    schedulerData.setDate(date);
    schedulerData.setEvents(this.state.EventsArr);
    this.setState({
      viewModel: schedulerData,
    });
    this.getShiftsandtaskNew("refresh");
  };

  eventClicked = (schedulerData, event) => {
    // console.log("eventClicked==>>", this.state.showEditShiftTaskUI)
    // schedulerData.setEvents(this.state.EventsArr);
    // this.setState({
    //   viewModel: schedulerData,
    // });
  };

  newEvent = (schedulerData, slotId, slotName, start, end, type, item) => {
    if (this.state.SchedulerAccess === "full") {
      this.setState({
        shownShiftTaskUI: !this.state.shownShiftTaskUI,
      });
    } else {
      ShowInfoSwal("Your user Role does not have access to this section");
    }
  };

  updateEventStart = (schedulerData, event, newStart) => {
    schedulerData.updateEventStart(event, newStart);
    this.setState({
      viewModel: schedulerData,
    });
  };

  updateEventEnd = (schedulerData, event, newEnd) => {
    schedulerData.updateEventEnd(event, newEnd);
    this.setState({
      viewModel: schedulerData,
    });
  };

  onScrollRight = (schedulerData, schedulerContent, maxScrollLeft) => {
    if (schedulerData.ViewTypes === ViewTypes.Day) {
      schedulerData.next();
      schedulerData.setEvents(this.state.EventsArr);
      this.setState({
        viewModel: schedulerData,
      });
      schedulerContent.scrollLeft = maxScrollLeft - 10;
    }
  };

  onScrollLeft = (schedulerData, schedulerContent, maxScrollLeft) => {
    if (schedulerData?.ViewTypes === ViewTypes.Day) {
      schedulerData.prev();
      schedulerData.setEvents(this.state?.EventsArr);
      this.setState({
        viewModel: schedulerData,
      });
      schedulerContent.scrollLeft = 10;
    }
  };

  toggleExpandFunc = (schedulerData, slotId) => {
    schedulerData.toggleExpandStatus(slotId);
    this.setState({ viewModel: schedulerData });
  };
}

export default WithDragDropContext(Basic);
